export default __webpack_public_path__ + "static/media/move-arrow-blue.73e53906.svg";